module.exports = __webpack_public_path__ + "img/SchlitzohrSpitzOhr.cf3321d4.svg";